import { sortRecords } from '../../helpers';

const sortPolicies = (policies, sortBy, order) =>
  sortRecords(policies, sortBy, order);

export default sortPolicies;
